// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2uyPw","file":"styles_file__3VLpY"};